import React from 'react';
import { ArrowLeft, FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Terms = ({ onNavigate }) => {
  const { t } = useTranslation();
  const acceptableUseItems = t('terms.sections.acceptableUse.items', { returnObjects: true });

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-10 max-w-3xl w-full">
        <button
          onClick={() => onNavigate('/')}
          className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 mb-6"
        >
          <ArrowLeft className="w-4 h-4" />
          {t('terms.backToDashboard')}
        </button>

        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
            <FileText className="w-5 h-5 text-purple-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{t('terms.title')}</h1>
            <p className="text-sm text-gray-600">{t('terms.lastUpdated')}</p>
          </div>
        </div>

        <div className="space-y-5 text-sm sm:text-base text-gray-700 leading-relaxed">
          <p>{t('terms.intro')}</p>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('terms.sections.eligibility.title')}</h2>
            <p>{t('terms.sections.eligibility.body')}</p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('terms.sections.yourContent.title')}</h2>
            <p>{t('terms.sections.yourContent.body')}</p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('terms.sections.acceptableUse.title')}</h2>
            <ul className="list-disc pl-5 space-y-1">
              {acceptableUseItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('terms.sections.payments.title')}</h2>
            <p>{t('terms.sections.payments.body')}</p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('terms.sections.disclaimer.title')}</h2>
            <p>{t('terms.sections.disclaimer.body')}</p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('terms.sections.changes.title')}</h2>
            <p>{t('terms.sections.changes.body')}</p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('terms.sections.contact.title')}</h2>
            <p>{t('terms.sections.contact.body', { email: 'support@mymanifest.app' })}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
